import { toast } from '@randstad-lean-mobile-factory/react-components-core';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { AddAppDetailsParams, HomeEditionService } from 'src/Services/API';

import { MutationKeys, QueryKeys } from '../types';

export const useAddAppDetails = () => {
  const queryClient = useQueryClient();

  return useMutation(
    [MutationKeys.addAppDetails],
    async (params: AddAppDetailsParams) => {
      return HomeEditionService.homeEditionControllerAddAppDetails({ body: params });
    },
    {
      onSuccess: () => {
        toast.success("les détails de l'app ont été créés");
        queryClient.invalidateQueries({ queryKey: [QueryKeys.fetchAppDetails] });
      },
      onError: (error: AxiosError) => {
        queryClient.invalidateQueries({ queryKey: [QueryKeys.fetchAppDetails] });
        switch (error.response?.status) {
          case 403:
            toast.error("droits insuffisants pour ajouter les détails d'une app");
            break;
          case 409:
            toast.error(
              "l'app a déjà des détails renseignés, modifiez les existants plutôt que d'en créer des nouveaux"
            );
            break;
          default:
            toast.error("erreur lors de la création des détails de l'app");
            break;
        }
      },
    }
  );
};
